module.exports = __webpack_public_path__ + "static/xav-ski.298f6070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/xav-ski.jpg
// module id = 749
// module chunks = 263791100135453